<div class="validation-message-modal-container">
    <div class="modal-header">
        <div class="modal-title">
            SUBMIT ISSUE
        </div>
        <div class="modal-close-button" (click)="onCloseButtonClick()">
            <img src="" class="closeIcon" />
        </div>
    </div>
    <div class="modal-body">
        <ng-container >
            <div class="validation-message-container">
                <img class="validation-icon" src="assets/status-amber.svg"/>
                <div class="validation-message-text">
                    Please select different KPIs, another user already 
                    submitted same configurations on the following KPIs:
                </div>
                <div class="validation-kpi-list-container">
                    <div class="kpi-list">
                        <ul *ngFor="let kpi of configuredKpiList" >
                            <li appTooltip="{{kpi.name}}" [tooltipPosition]="'top'"
                                [tooltipShow]="(kpi.name.length) > 24">
                                {{kpi.name | shorten: 24}}
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="close-button-container">
                <button (click)="onCloseButtonClick()" class="close-button">
                    <div class="close-button-text">
                        CLOSE
                    </div>
                </button>
            </div>
        </ng-container>
    </div>
</div>